var _excluded = ["children", "labelDirection", "labelBlock", "tabIndex", "id", "classes"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import { PropTypes } from "prop-types";
import Icon from "@xo-union/tk-component-icons";
import { useClasses } from "@xo-union/react-css-modules";
import { useUniqueID } from "@xo-union/react-unique-id";
import classesPropType from "@xo-union/classes-prop-type";
import cx from "classnames";
import { Caption } from "@xo-union/tk-ui-typography";
import styles from "./styles.css";
import InteractiveElement from "../InteractiveElement/index.js";
import { useCheckedContextProps } from "../Context.js";

/**
 * Render checkbox.
 *
 * #### Ref API
 *
 * | type | description |
 * |------|-------------|
 * | `HTMLDivElement` | Element that user interacts with. |
 */
var Checkbox = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    labelDirection = props.labelDirection,
    labelBlock = props.labelBlock,
    tabIndex = props.tabIndex,
    idProp = props.id,
    classesProp = props.classes,
    rest = _objectWithoutProperties(props, _excluded);
  var id = useUniqueID(idProp);
  var labelID = useUniqueID(idProp && "".concat(idProp, "-label"));
  var classes = useClasses(styles, classesProp);
  var _useCheckedContextPro = useCheckedContextProps(rest),
    value = _useCheckedContextPro.value,
    checked = _useCheckedContextPro.checked,
    onChange = _useCheckedContextPro.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(classes.container, classes["has-".concat(labelDirection, "-label")], labelBlock && classes['has-block-label'], checked && classes['is-selected'])
  }, /*#__PURE__*/React.createElement("input", _extends({
    className: classes.input,
    type: "checkbox",
    id: id
  }, rest, {
    value: value,
    checked: checked,
    onChange: onChange
  })), /*#__PURE__*/React.createElement("label", {
    id: labelID,
    className: classes.label,
    htmlFor: id
  }, /*#__PURE__*/React.createElement(InteractiveElement, {
    ref: ref,
    className: classes['checkmark-container'],
    tabIndex: tabIndex,
    role: "checkbox",
    "aria-checked": checked,
    "aria-labelledby": labelID
  }, /*#__PURE__*/React.createElement(Caption, {
    className: classes['checkmark-border']
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "checkmark_mini",
    size: "md",
    className: classes.checkmark
  }))), /*#__PURE__*/React.createElement("span", {
    className: classes['label-text']
  }, children)));
});
process.env.NODE_ENV !== "production" ? Checkbox.propTypes = {
  /**
   * Override the generated id
   */
  id: PropTypes.string,
  /**
   * The labels content.
   */
  children: PropTypes.node,
  /**
   * The value to set when this checkbox is checked.
   */
  value: PropTypes.string,
  /**
   * Used to force the checked state
   */
  checked: PropTypes.bool,
  /**
   * Callback for when user selects a value.
   */
  onChange: PropTypes.func,
  /**
   * Class dependencies
   */
  classes: classesPropType(['container', 'is-selected', 'input', 'label', 'checkmark-container', 'checkmark-border', 'checkmark', 'has-left-label', 'has-right-label', 'has-block-label']),
  /**
   * Direction where label should be placed
   */
  labelDirection: PropTypes.oneOf(['left', 'right']),
  /**
   * Force label to take block spacing
   */
  labelBlock: PropTypes.bool,
  /**
   * Set checkboxes tab index
   */
  tabIndex: PropTypes.string
} : void 0;
Checkbox.defaultProps = {
  labelDirection: 'right',
  labelBlock: false,
  tabIndex: '0'
};
export default Checkbox;